<template>
  <div>
    <my-dialog
      :is-show-footer="false"
      :dialog-carted="videoButton"
      :width="600"
      form-title="心电图"
      @confirmOk="closeDialog"
    >
      <template #content>
        <!-- 如果有视频的内容的话 -->
        <div v-if="hasData">
          <!--        <div v-if="true">-->
          <div class="select-video">
            <el-select
              v-model="heartTimePath"
              placeholder="请选择时间"
              @change="selectVideo"
            >
              <el-option
                v-for="item in heartData"
                :key="item.start"
                :label="item.start"
                :value="item.filename"
              />
            </el-select>
          </div>
          <div id="mse"/>
        </div>
        <div v-else>
          <img src="@/assets/photos/640.png" style="height: 360px" alt="">
        </div>
      </template>
    </my-dialog>
  </div>
</template>

<script>
import MyDialog from "@components/customDialog/MyDialog";
import { getHeartVideo } from "@/api/streamdata";
import Player from "xgplayer";
import { baseUrl } from "@/utils/base";
import { showWindowMessage } from "@utils/notification";

export default {
  name: "HeartShow",
  components: {
    MyDialog
  },
  props: {
    videoButton: {
      type: Boolean,
      default() {
        return false;
      }
    },
  },
  emits: ["closeDialog"],
  data() {
    return {
      hasData: false, // 有视频数据
      heartTimePath: "", // 心电图时间
      heartData: [],
      player: null,
      completeHeartUrl: "",
      baseUrl: baseUrl,
    };
  },
  watch: {
    videoButton: {
      handler(newVal, old) {
        if (newVal) {
          this.getHeartData();
        } else {
          !!this.player && this.player.pause();
        }
      },
      immediate: true
    },
  },
  beforeUnmount() {
    this.player?.destroy(false);
  },
  methods: {
    selectVideo(path) {
      this.player.src = this.baseUrl + path;
    },
    async getHeartData() {
      try {
        const patientID = this.$route.params.id;
        const { code, data, msg } = await getHeartVideo(patientID);
        if (code !== 200) {
          this.hasData = false;
          showWindowMessage(3, msg, this);
        } else {
          this.hasData = true;
          this.heartData = data;
          await this.$nextTick(() => {
            this.heartTimePath = this.heartData[0].filename;
            this.completeHeartUrl = this.baseUrl + this.heartTimePath;
            this.getPlayer();
          });
        }
      } catch (e) {
        showWindowMessage(3, e, this);
      }
    },
    getPlayer() {
      if (this.player) {
        this.player = null;
      }
      this.player = new Player({
        el: document.querySelector("#mse"),
        url: this.completeHeartUrl,
        videoInit: true,
        loop: true,
        playbackRate: [0.5, 0.75, 1, 1.25], // 传入倍速可选数组
        defaultPlaybackRate: 1,

      });
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
  }
};
</script>

<style scoped lang="scss">

</style>
